module.exports = __webpack_public_path__ + "img/signal-bars-fair.613cd4fd.svg";